import NBType, { InferType } from '@netbase/nb-type'
import InsightCategoryGroupSchema from './InsightCategoryGroupSchema'
import InsightGroupInfoSchema from './InsightGroupInfoSchema'

const InsightCountSchema = NBType.object().shape('InsightCountSchema', {
  errorCode: NBType.number(),
  errorParams: NBType.array().of(NBType.string()),
  insightGroupInfos: NBType.array().of(NBType.array().of(InsightGroupInfoSchema)),
  insights: NBType.array().of(InsightCategoryGroupSchema)
})

export default InsightCountSchema
export type InsightCount = InferType<typeof InsightCountSchema>
// RESERVE BELOW
